import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useTestList = (params?: any) => {
  return useQuery({
    queryKey: ['test-list', params],
    queryFn: async () => {
      const res = await request.get('/test', { params });
      return res.data;
    }
  });
};
